/**
 * Соответствует стандартному формату: user@example.com
 */
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

/**
 * Ограничения для email согласно RFC 5321
 */
export const EMAIL_CONSTRAINTS = {
	MIN_LENGTH: 5,
	MAX_LENGTH: 254
} as const
